import { type PressEventHandler } from '@/infra/prop-types'

/**
 * This is a (temporary I hope) workaround for a bug in React Aria where the element
 * behind a pressed element receives the press as well.
 * Once fixed we should be able to remove this and update usages.
 *
 * @see {@link }https://github.com/adobe/react-spectrum/issues/1513}
 *
 * @param handler
 */
export function withPressHack(
  handler: PressEventHandler | (() => unknown),
): PressEventHandler {
  return (e) => {
    requestAnimationFrame(() => requestAnimationFrame(() => handler(e)))
  }
}
